import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import ModalDialog from '@/components/ModalDialog/ModalDialog';
import { AppContext } from '@/AppContext';
import ErrorBlock from '@/components/ErrorBlock/ErrorBlock';
import { Grid } from '@mui/material';
import { convertErrors, MyFormTextField } from '../../../MeetupList/components/MeetupEditForm/MeetupEditForm';

const ChangeBalance = props => {
  const appContext = useContext(AppContext);
  const { accountId } = useParams();
  const { goBack } = props;

  const [errors, setErrors] = useState([]);

  const [formState, setFormState] = useState({
    values: {
      amount: 0,
      comment: '',
    },
    errors: {},
    touched: {},
    isValid: true,
  });

  const handleSave = () => {
    appContext.accountApi
      .changeBalance(accountId, formState.values)
      .then(({ data }) => {
        goBack(data);
      })
      .catch(error => {
        const data = error.response.data;
        setErrors(data.errors || [data]);
      });
  };

  useEffect(() => {
    if (errors) {
      setFormState({
        ...formState,
        ...convertErrors(errors),
      });
    }
  }, [errors]);

  const handleChange = (name, value) => {
    formState.values[name] = value;
    formState.touched[name] = true;

    setFormState(formState => {
      return {
        ...formState,
        isValid: true,
        errors: {},
      };
    });
  };

  const error = field => {
    if (!formState.touched || !formState.errors) {
      return null;
    }
    if (formState.touched[field] && formState.errors[field]) {
      return formState.errors[field];
    } else {
      return null;
    }
  };

  const form = {
    // form values bind helper
    data: formState,
    handleChange: handleChange,
    error: error,
  };
  return (
    <ModalDialog title={'Изменение баланса'} okButtonText={'Сохранить'} handleOk={handleSave} handleClose={goBack}>
      <ErrorBlock message={formState.error} />
      <Grid container spacing={3}>
        <Grid size={12}>
          <MyFormTextField name={'amount'} label='Сумма (для добавления)' required {...form} />
        </Grid>
        <Grid size={12}>
          <MyFormTextField name={'comment'} label='Комментарий' {...form} />
        </Grid>
      </Grid>
    </ModalDialog>
  );
};

ChangeBalance.propTypes = {};

export default ChangeBalance;
